import React, { useEffect, useState } from 'react';
import { ReactComponent as PollIcon } from '../../assets/svg/PollIcon.svg';
import { ReactComponent as QuestionIcon } from '../../assets/svg/QuestionIcon.svg';
import { ReactComponent as PostIcon } from '../../assets/svg/PostIcon.svg';
import { ReactComponent as EditContent } from '../../assets/svg/EditContent.svg';
import { ReactComponent as DeleteContent } from '../../assets/svg/DeleteContent.svg';
import { format_day, notify, translateTargetText } from '../../utils/util';
import { fileSystemUrl } from '../../constants/Connections';
import { useUser } from '../../auth';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { approveContentAsync, sendNotification } from '../../server/server';
import { useSocket } from '../../context/socket';

const IconMap = {
	poll: <PollIcon />,
	question: <QuestionIcon />,
	feed: <PostIcon />,
};

function UpcomingSingleContent({ content, handleDelete, openBigImage, reviewContent = false, reloadContent = () => {} }) {
	const { user, setUser } = useUser();
	const { socketStates, socket, changeSocketState } = useSocket();
	const history = useHistory();
	const { t, locale, i18n } = useTranslation();

	const showImage = (files, width) => {
		if (files) {
			return (
				<div className='image-container'>
					<img
						src={fileSystemUrl + '/' + files?.storage_name + '?token=' + user?.token + '&width=' + width}
						alt='Task'
						className='task-image'
						style={{ width: `${width}px` }}
					/>
				</div>
			);
		}
	};

	const handleEdit = () => {
		document.getElementById('home').style.filter = 'none';
		document.getElementById('upcoming-content-modal-trigger').style.display = 'flex';
		history.push(`/content?editId=${content?.id}`);
	};

	const approve = async (approved) => {
		const data = {
			content_id: content.id,
			approved,
		};

		const resp = await approveContentAsync(data);
		if (resp.status === 200) {
			const data = resp.data;
			const content = data;
			socket?.emit('new_content', data);
			sendNotification({ content, type: 'task' });
			sendNotification({ content, type: 'reviewed' });
			notify(t(`${approved ? 'Content has been approved' : 'Content has been declined'}`));
			reloadContent();
		}
	};

	return (
		<div className='bg-containerGray w-100% rounded-xl mb-4 p-3 mx-8' key={content?.id}>
			<div className='header-single-content flex flex-row justify-between ' style={{ alignItems: 'start' }}>
				<div className='flex flex-row items-center gap-2'>
					{IconMap[content?.type]}{' '}
					<span className='text-mudPurple font-medium text-sm'>
						{t('Open')} {t(content?.type)}
					</span>
				</div>

				{!reviewContent && (
					<div className='flex flex-row items-center gap-3'>
						{content?.type !== 'journal' && (
							<EditContent
								style={{ cursor: 'pointer' }}
								fill='#BEBECE'
								onClick={(e) => {
									e.stopPropagation();

									handleEdit();
								}}
							/>
						)}

						<DeleteContent
							className='cursor-pointer'
							fill='#FF747F'
							onClick={(e) => {
								e.stopPropagation();

								handleDelete(content);
							}}
						/>
					</div>
				)}
				{reviewContent && (
					<span className='text-[#9392ad99]  text-sm'>
						{t('by')}: {content?.created_by?.first_name} {content?.created_by?.last_name}
					</span>
				)}
			</div>
			{content?.files && (
				<div
					className='mr-3 my-2 cursor-pointer'
					onClick={() => openBigImage(fileSystemUrl + '/' + content?.files?.storage_name + '?token=' + user?.token)}
				>
					{showImage(content?.files, 180)}
				</div>
			)}
			<div className='text-deepPurple mt-3 font-bold text-lg text-left max-w-xs'>{content?.title}</div>
			<p className='text-sm text-deepPurple text-left mt-3'>{content?.description}</p>
			<div>
				{content?.type === 'poll' && (
					<div className='mt-3 text-left'>
						<span className='text-[12px] text-mudPurple  mb-2'>{t('options')} </span>
						{content?.options.map((option, index) => {
							return (
								<div
									key={index}
									className='text-[16px] text-mudPurple bg-white rounded-xl w-full py-[0.6rem] mb-2 text-left px-3'
								>
									{option}
								</div>
							);
						})}
					</div>
				)}
			</div>
			{reviewContent && (
				<div className='flex flex-row gap-[10px]'>
					<button
						className={`h-[50px] border border-[#BEBECE] flex-1 rounded-[10px] bg-[#FAFAFF] text-[#9392AD] text-[16px] font-semibold transition hover:bg-[#BEBECE] hover:text-[white]`}
						onClick={() => approve(false)}
					>
						{t('Decline')}
					</button>
					<button
						className={`h-[50px] border border-[#5E639B] flex-1 rounded-[10px] bg-[#5E639B] text-[#FDDF6D] text-[16px] font-semibold transition hover:bg-[#FDDF6D] hover:text-[#5E639B] hover:border-[#FDDF6D]`}
						onClick={() => approve(true)}
					>
						{t('Accept')}
					</button>
				</div>
			)}
			<div className='flex justify-between items-center mt-3'>
				<span className='text-mudPurple font-medium text-sm'>
					<span className='text-[#9392ad99] text-sm'>{t('target')} :</span> {translateTargetText(content?.target_text)}
				</span>
				<p>
					<span className='text-[#9392ad99]  text-sm'>
						{t('date')} & {t('time')}:{' '}
					</span>
					<span className='text-mudPurple text-sm '>{format_day(content?.publicationDate, true, i18n.language)}</span>
				</p>
			</div>
		</div>
	);
}

export default UpcomingSingleContent;
